import { render, staticRenderFns } from "./siteDetection.vue?vue&type=template&id=155bb499&scoped=true&"
import script from "./siteDetection.vue?vue&type=script&lang=js&"
export * from "./siteDetection.vue?vue&type=script&lang=js&"
import style0 from "./siteDetection.vue?vue&type=style&index=0&id=155bb499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155bb499",
  null
  
)

export default component.exports